'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Footer = exports.Body = exports.Header = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _recompose = require('recompose');

var _Modal = require('react-bootstrap/lib/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _modal = require('./modal.css');

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _recompose.compose)((0, _recompose.setPropTypes)({
  className: _propTypes2.default.string,
  closeable: _propTypes2.default.bool,
  size: _propTypes2.default.oneOf(['small', 'large', 'default']),
  onClose: _propTypes2.default.func,
  keyboard: _propTypes2.default.bool,
  animate: _propTypes2.default.bool
}), (0, _recompose.setDisplayName)('Modal'))(function (_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$closeable = _ref.closeable,
      closeable = _ref$closeable === undefined ? true : _ref$closeable,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 'large' : _ref$size,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === undefined ? function () {} : _ref$onClose,
      _ref$keyboard = _ref.keyboard,
      keyboard = _ref$keyboard === undefined ? true : _ref$keyboard,
      _ref$animate = _ref.animate,
      animate = _ref$animate === undefined ? false : _ref$animate,
      children = _ref.children;
  return _react2.default.createElement(
    _Modal2.default,
    {
      show: true,
      onHide: onClose,
      keyboard: keyboard,
      animation: animate,
      autoFocus: true,
      backdrop: closeable ? true : 'static',
      bsSize: size === 'default' ? undefined : size,
      dialogClassName: className + ' ' + _modal2.default.__modal },
    _react2.default.Children.map(children, function (child) {
      return child.type === Header ? _react2.default.cloneElement(child, { closeable: closeable, onClose: onClose }) : child;
    })
  );
});
var Header = exports.Header = (0, _recompose.compose)((0, _recompose.setPropTypes)({
  closeable: _propTypes2.default.bool,
  onClose: _propTypes2.default.func
}), (0, _recompose.setDisplayName)('ModalHeader'))(function (_ref2) {
  var children = _ref2.children,
      closeable = _ref2.closeable,
      onClose = _ref2.onClose;
  return _react2.default.createElement(
    _Modal2.default.Header,
    { closeButton: closeable, onHide: onClose },
    _react2.default.createElement(
      _Modal2.default.Title,
      null,
      children
    )
  );
});

var Body = exports.Body = (0, _recompose.setDisplayName)('ModalBody')(function (_ref3) {
  var children = _ref3.children;
  return _react2.default.createElement(
    _Modal2.default.Body,
    null,
    children
  );
});
var Footer = exports.Footer = (0, _recompose.setDisplayName)('ModalFooter')(function (_ref4) {
  var children = _ref4.children;
  return _react2.default.createElement(
    _Modal2.default.Footer,
    null,
    children
  );
});